import React, { useState, useEffect } from 'react';
import './OnboardingStep.css';

const OnboardingStep = ({
  stepNumber,
  totalSteps,
  title,
  subtitle,
  options,
  showOtherInput = false,
  selectedOptions = [],
  onDataChange,
  onNext,
  onBack,
}) => {
  const [otherText, setOtherText] = useState('');
  const [customOptions, setCustomOptions] = useState([]);

  useEffect(() => {
    // Filter out any custom options that may be reloaded from selectedOptions
    const predefinedLabels = options.map((o) => (typeof o === 'string' ? o : o.label));
    const inferredCustoms = selectedOptions.filter((opt) => !predefinedLabels.includes(opt));
    setCustomOptions(inferredCustoms);
  }, [options, selectedOptions]);

  const toggleOption = (label) => {
    const updated = selectedOptions.includes(label)
      ? selectedOptions.filter((o) => o !== label)
      : [...selectedOptions, label];
    onDataChange(updated);
  };

  const handleOtherAdd = () => {
    const trimmed = otherText.trim();
    if (trimmed && !selectedOptions.includes(trimmed)) {
      const updated = [...selectedOptions, trimmed];
      setCustomOptions((prev) => [...prev, trimmed]);
      onDataChange(updated);
      setOtherText('');
    }
  };

  const removeCustomOption = (label) => {
    const updated = selectedOptions.filter((o) => o !== label);
    setCustomOptions((prev) => prev.filter((o) => o !== label));
    onDataChange(updated);
  };

  return (
    <div className="onboarding-step-container">
      <div
        className="step-progress"
        style={{ '--step': stepNumber, '--total-steps': totalSteps }}
      >
        {Array.from({ length: totalSteps }).map((_, index) => (
          <div
            key={index}
            className={`step-circle ${index + 1 <= stepNumber ? 'active' : ''}`}
          />
        ))}
      </div>

      <div className="step-card">
        <p className="step-label">
          STEP {stepNumber}/{totalSteps}
        </p>
        <h2 className="step-title">{title}</h2>
        <p className="step-subtitle">{subtitle}</p>

        <div className="options-grid">
          {options.map((option, idx) => {
            const label = typeof option === 'string' ? option : option.label;
            const subtext = typeof option === 'object' && option.subtext;

            return (
              <label key={idx} className="option-item">
                <div className="option-texts">
                  <span className="option-main">{label}</span>
                  {subtext && <span className="option-sub">{subtext}</span>}
                </div>
                <input
                  type="checkbox"
                  checked={selectedOptions.includes(label)}
                  onChange={() => toggleOption(label)}
                />
              </label>
            );
          })}

          {customOptions.map((label, idx) => (
            <div key={`custom-${idx}`} className="option-item">
              <div className="option-texts">
                <span className="option-main">{label}</span>
              </div>
              <button
                className="remove-btn"
                onClick={() => removeCustomOption(label)}
                aria-label="Remove custom option"
              >
                ✕
              </button>
            </div>
          ))}

          {showOtherInput && (
            <div className="other-option">
              <input
                type="text"
                placeholder="Other (Please Specify)"
                value={otherText}
                onChange={(e) => setOtherText(e.target.value)}
              />
              <button className="add-btn" onClick={handleOtherAdd}>
                Add
              </button>
            </div>
          )}
        </div>

        <div className="step-footer">
          {stepNumber > 1 && (
            <button className="back-btn" onClick={onBack}>
              ← Back
            </button>
          )}
          <button className="next-btn" onClick={onNext}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default OnboardingStep;
